module.exports = __webpack_public_path__ + "img/MOBILE-VTA-VALORACION-DOMICILIO.ebedde47.png";